import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppDispatch } from "../../store/store";
import {
  setDraftParticipants,
  setSelectedConversation,
} from "../../store/slices/conversation.slice";
import { setSelectedDid } from "../../store/slices/SmsDids.slice";

export function useElectronIncomingSmsNotification(enabled = true): void {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location.pathname);
  locationRef.current = location.pathname;

  useEffect(() => {
    if (!enabled) return;

    const api = window.electronAPI;
    if (!api?.onIncomingSmsNotificationClicked) return;

    return api.onIncomingSmsNotificationClicked(({ did, conversationId, participants, type, participant }) => {
      dispatch(setSelectedDid(did));
      const resolvedParticipants = participants?.length
        ? participants
        : participant
          ? [participant]
          : [];

      if (conversationId && resolvedParticipants.length) {
        dispatch(setSelectedConversation({
          did,
          conversation_id: conversationId,
          participants: resolvedParticipants,
          type: type || (resolvedParticipants.length > 1 ? "group" : "direct"),
        }));
      } else {
        dispatch(setSelectedConversation(null));
        if (resolvedParticipants.length) {
          dispatch(setDraftParticipants(resolvedParticipants));
        }
      }

      if (locationRef.current !== "/") {
        navigate("/");
      }
    });
  }, [enabled, dispatch, navigate]);
}
